import api from "./ajax";

document.addEventListener('DOMContentLoaded', function () {
	const toggles = document.querySelectorAll('[data-action="staff-toggle-active"]');

	toggles.forEach((toggle) => {
		toggle.addEventListener('change', async function () {
			const staffId = this.dataset.staffId;
			const isActive = this.checked;

			try {
				const response = await api.setStaffActiveStatus(staffId, isActive);

				if (response.error) {
					throw new Error('Server returned error');
				}

				// Optionally show a toast or success message
				console.log(`Staff ${staffId} is now ${isActive ? 'active' : 'inactive'}.`);
			} catch (err) {
				console.error('Failed to update staff active status:', err);

				// Revert toggle on failure
				this.checked = !isActive;

				// Optionally show an alert or toast
				alert('Failed to update status. Please try again.');
			}
		});
	});
});